module.exports = __webpack_public_path__ + "img/thank_2021_tip4_small.45c98007.png";